import auctionDialog from './auctionDialog.vue'
export default auctionDialog